import { useQuery } from "react-query";
import API from "../../../services/API";
import { useParams } from "react-router-dom";
import useCart from "./useCart";

const priority = {
    'dpc-pi': 1,
    'dpc': 2,
    'fifpl': 3,
    'fafpm': 4,
    'opco': 5,
    'etudiant': 6,
    'standard': 7
};

const rank = product => priority[product?.variant?.id] || 999;

export default function useProducts(){

    const { id } = useParams()

    const { cart, setCart } = useCart();

    const category = cart.category

    const status = cart.status

    return useQuery({

        queryKey: ['apply', 'products', id, category, status],

        queryFn: async () => {

            if(!id || !category || !status) return [];

            try{

                const response = await API.get(`/courses/${id}/products?category=${category}&status=${status}`);

                if( !response.data.products ) return [];

                const products = response.data.products.sort((a,b) => rank(a) - rank(b));

                let cartProps = { productsLoaded: true };

                if( products.length > 0 && !cart.product ) {
                    cartProps.product = products[0].id;
                }

                setCart(cartProps);

                return products;

            }catch(e){

                let code = e.response.status;

                setCart({ error: code === 409 ? 'conflict' : 'error' });

                return [];
            }
            
        }


    })
}